import zeroPadded from '../zero-padded';

const clockFormat = (totalSeconds, extractHours = false) => {
  if (!extractHours) {
    return { ...convertSecondsToMinutesAndSeconds(totalSeconds) };
  }

  const hours = Math.floor(totalSeconds / 3600);
  const remainingSeconds = totalSeconds % 3600;

  return {
    hours,
    ...convertSecondsToMinutesAndSeconds(remainingSeconds),
  };
};

const convertSecondsToMinutesAndSeconds = secs => ({
  minutes: zeroPadded(Math.floor(secs / 60)),
  seconds: zeroPadded(secs % 60),
});

export default clockFormat;



// WEBPACK FOOTER //
// ../utils/functions/clock-format/index.js